import { useTranslator, useDateFormatter } from '@bluebeam/react-i18n';
import React from 'react';
import { Project } from 'records/Project';
import { User } from 'records/User';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import AdminCard from './AdminCard';
import LocationCard from './Location';

interface Props extends WithAppStoreProps {
  onEditClicked: () => void;
  onViewTeamClicked: () => void;
  center?: any;
  zoom?: number;
  mapOptions?: any;
  projectData: Project | null;
}

const ProjectInfo: React.FC<Props> = (props: Props) => {
  const { onEditClicked, onViewTeamClicked, appState, projectData } = props;
  const { users } = appState;
  const { translate } = useTranslator(['roverDashboard']);

  const getCreatedUser = () => {
    if (!projectData) {
      return;
    }

    return users.get(projectData?.createdBy, new User());
  };

  const getCreatedDate = () => {
    if (!projectData) {
      return;
    }
    return new Date(projectData?.createdDate * 1000);
  };

  const createdUser = getCreatedUser();
  const createdDate = getCreatedDate();
  const canEdit = projectData?.permissions.managePeople;

  const dateFormatter = useDateFormatter({
    dateStyle: 'medium',
  });

  return (
    <div className="flex column justify-between mt4">
      <div className="flex justify-between">
        <div className="bold font-size-9 mb3">
          <div className="bold font-size-9 mb3">{projectData?.name}</div>
        </div>
      </div>
      {projectData && projectData.code.length > 0 ? (
        <div className="mb2">{projectData.code}</div>
      ) : (
        <div />
      )}

      <div className="mb5 color-gray-6 font-size-2">
        {translate('roverDashboard:createdOn', {
          dateTime: dateFormatter.format(createdDate ?? new Date()),
          userEmailAddress: createdUser?.email ?? '',
        })}
      </div>
      {canEdit || (projectData && projectData.street.length > 0) ? (
        <div className="flex column w100">
          <div className="mo-column lu-row justify-between w100 mb4">
            {projectData && (
              <LocationCard
                onEditClicked={onEditClicked}
                selectedProjectData={projectData}
              />
            )}

            <div className="lu-hide mb4 shrink-0" />

            {canEdit ? (
              <>
                <div className="lu-show wrem-1p5 shrink-0" />
                <AdminCard onViewTeamClicked={onViewTeamClicked} />
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

ProjectInfo.defaultProps = {
  center: { lat: 34.14, lng: -118.16 },
  zoom: 12,
  mapOptions: { fullscreenControl: false },
};

export default withAppStore<Props>(ProjectInfo);
